import type { ImageGenerationProviderChannel } from '../../../api'
import { makeMentionToken, parsePromptText } from './assetMention'
import { PROVIDER_CHANNEL_BFL, PROVIDER_CHANNEL_LOCAL } from './imageGenerationProvider'

export function imageProviderRecommendsPromptTranslation(
  channel: ImageGenerationProviderChannel | null | undefined,
): boolean {
  if (!channel) return false
  if (channel.prompt_translation_recommended === true) return true
  if (channel.preferred_prompt_language === 'en') return true
  if (channel.id === PROVIDER_CHANNEL_LOCAL || channel.id === PROVIDER_CHANNEL_BFL) return true
  const providerId = (channel.provider_id || '').toLowerCase()
  return providerId === 'local_flux' || providerId === 'bfl'
}

/** Replace Canvas mention markers with stable placeholders before translation. */
export function preparePromptTextForTranslation(text: string): {
  textForTranslation: string
  mentionPlaceholders: Map<string, string>
} {
  const mentionPlaceholders = new Map<string, string>()
  let assetIndex = 0
  const segments = parsePromptText(text)
  const textForTranslation = segments
    .map((seg) => {
      if (seg.type === 'mention') {
        const key = `__ASSET_${assetIndex}__`
        assetIndex += 1
        mentionPlaceholders.set(key, makeMentionToken(seg.edgeId, seg.aliasHint))
        return key
      }
      return seg.value
    })
    .join('')
  return { textForTranslation, mentionPlaceholders }
}

export function reassemblePromptAfterTranslation(
  translated: string,
  mentionPlaceholders: Map<string, string>,
): string {
  let out = translated
  for (const [key, token] of mentionPlaceholders) {
    out = out.replaceAll(key, token)
  }
  return out
}

export function promptAppearsMostlyEnglish(text: string): boolean {
  const stripped = (text || '').trim()
  if (!stripped) return false
  const cjk = (stripped.match(/[\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaff]/g) || []).length
  const latin = [...stripped].filter((ch) => /[A-Za-z]/.test(ch)).length
  if (cjk === 0) return true
  if (latin === 0) return false
  return cjk / Math.max(1, cjk + latin) < 0.15
}
